<div class="container">
    <div class="row">
        <div class="col-md-3">
            <label for="year">Seleccione Año</label>
            <select id="year" class="form-control" change="onYearChange($event)">
                <option value="" disabled>Seleccione un año</option>
                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
            </select>
        </div>

        <!-- seleccionar periodo -->

        <div class="col-md-3">
            <label for="period">Seleccione Periodo</label>
            <div *ngIf="periods.length === 0" class="text-danger mt-2">
                No hay periodos disponibles para el año seleccionado.
            </div>
            <select *ngIf="periods.length > 0" id="period" class="form-control" [(ngModel)]="selectedPeriod">
                <option value="" disabled>Seleccione un periodo</option>
                <option *ngFor="let period of periods" [value]="period._id">{{ period.name }}</option>
            </select>
        </div>

        <div class="col-md-2  mt-2">
            <button class="btn btn-secondary btn-sm w-100" (click)="onSearch()">Buscar</button>
        </div>


    </div>

    <div class="row mt-4" *ngIf="reportPayments.length > 0">
        <div class="table-responsive">
            <table class="table table-hover table-sm align-middle border border-secondary rounded-4">
                <thead class="table-primary text-center form-label-sm">
                    <tr>
                        <th>Título</th>
                        <th>Cantidad Pagos</th>
                        <th>Monto Total</th>
                        <th>Documentos</th>
                        <th>Fecha de Pago</th>
                        <th>Descripción</th>
                        <!--  <th>Acciones</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let payment of reportPayments" class="text-center form-label-sm">
                        <td>{{ payment.title }}</td>
                        <td>{{ payment.reports.length }}</td>
                        <td>${{ payment.ammount | number: '1.0-0':'es-ES' }}</td>
                        <td class="text-start">
                            <div *ngIf="payment.files?.length > 0; else noAttachments">
                                <ul class="list-unstyled mb-0">
                                    <li *ngFor="let attachment of payment.files">
                                        <button class="btn btn-outline-primary btn-sm mt-1" title="Ver Adjunto"
                                            (click)="onOpenAttachment(attachment)">
                                            <i class="fas fa-folder"></i>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <ng-template #noAttachments>
                                <span class="text-muted">Sin adjuntos</span>
                            </ng-template>
                        </td>

                        <td>{{ payment.createdAt | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ payment.comment }}</td>
                        <!--   <td>
                        <button class="btn btn-primary btn-sm">
                            Ver Detalles
                        </button>
                    </td> -->
                    </tr>
                </tbody>


            </table>
        </div>
    </div>

    <p *ngIf="reportPayments.length === 0" class="text-center">No se encontraron pagos para el periodo seleccionado.</p>

    <div class="modal fade" #AttachmentModal tabindex="-1" class="modal fade" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-primary" id="viewAttachmentModalLabel">Visor de Adjuntos</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                </div>

                <div class="modal-body">
                    <app-attachment-viewer>
                    </app-attachment-viewer>
                </div>
                <div class="modal-footer">

                </div>
            </div>
        </div>
    </div>